export default {
    'create-warehouse': 'إنشاء مستودع',
    'edit-warehouse': 'تعديل مستودع',
    'warehouse-name': 'اسم المستودع',
    notes: 'ملاحظات',
    save: 'حفظ',
    cancel: 'إلغاء',

    'delete-the-warehouse': 'حذف المستودع',
    'are-you-sure-you-want-to-delete-the-warehouse': 'هل أنت متأكد من حذف المستودع؟',

    headers: {
        'no': 'الرقم',
        'warehouse-name': 'اسم المستودع',
        'notes': 'الملاحظات',
        'actions': 'الأحداث',
    }
}